import { api } from 'apis/restaurant-api/api';
import { PaginatedData, RestaurantApiCursorPaginationParams } from 'apis/restaurant-api/types';

import { Purchase } from './types';

/**
 * @param email
 * @param venueId
 * @param startDate
 * @param endDate - INCLUSIVE end date of range with requested receipts
 */
export const requestPurchaseReceiptArchive = (email: string, venueId: string, startDate: string, endDate: string) => {
  const data = {
    email,
    venue: venueId,
    start_date: startDate,
    end_date: endDate,
  };

  return api.post('/v1/merchant-admin/purchase/receipt_archive_link', data).then(res => res.data);
};

export const readCompletedPurchases = ({
  venueId,
  startTime,
  endTime,
  limit,
  cursor,
  pivotId,
}: RestaurantApiCursorPaginationParams<{
  venueId: string;
  startTime: string;
  endTime: string;
}>) =>
  api
    .get<PaginatedData<{ purchases: Purchase[] }>>(`/v1/merchant-admin/venues/${venueId}/completed_purchases`, {
      params: {
        cursor,
        end_time: endTime,
        limit,
        // pivot_id causes the API to return a page starting with the purchase whose id is pivot_id
        pivot_id: pivotId,
        start_time: startTime,
      },
    })
    .then(response => response.data);

export const readRejectedPurchases = ({
  venueId,
  startTime,
  endTime,
  limit,
  cursor,
  pivotId,
}: RestaurantApiCursorPaginationParams<{
  venueId: string;
  startTime: string;
  endTime: string;
}>) =>
  api
    .get<PaginatedData<{ purchases: Purchase[] }>>(`/v1/merchant-admin/venues/${venueId}/rejected_purchases`, {
      params: {
        cursor,
        end_time: endTime,
        limit,
        // pivot_id causes the API to return a page starting with the purchase whose id is pivot_id
        pivot_id: pivotId,
        start_time: startTime,
      },
    })
    .then(response => response.data);

export const readPurchase = ({ venueId, purchaseId }: { venueId: string; purchaseId: string }) =>
  api.get<Purchase>(`/v1/merchant-admin/venues/${venueId}/purchases/${purchaseId}`).then(response => response.data);
